import React, { useContext } from "react";
import "./Home.css";
import bike from "../../assets/imgs/bike.png";
import car from "../../assets/imgs/car.png";
import bus from "../../assets/imgs/bus.png";
import train from "../../assets/imgs/train.png";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";

const Home = () => {
  const [whichVehicle, setWhichVehicle] = useContext(UserContext);
  const handleVehicleSelection = (vehicleName) => {
    const newVehicle = { ...whichVehicle };
    newVehicle.vehicle = vehicleName;
    setWhichVehicle(newVehicle);
  };
  return (
    <div>
      <main className="home">
        <div className="home-transport-div">
          <div className="transport-img-div">
            <img src={bike} alt="" />
          </div>
          <div className="transport-text-div">
            <h3>BIKE</h3>
            <Link
              to="/book-ride"
              className="home-link"
              onClick={() => handleVehicleSelection("bike")}
            >
              Book Now
            </Link>
          </div>
        </div>
        <div className="home-transport-div">
          <div className="transport-img-div">
            <img src={car} alt="" />
          </div>
          <div className="transport-text-div">
            <h3>CAR</h3>
            <Link
              to="/book-ride"
              className="home-link"
              onClick={() => handleVehicleSelection("car")}
            >
              Book Now
            </Link>
          </div>
        </div>
        <div className="home-transport-div">
          <div className="transport-img-div">
            <img src={bus} alt="" />
          </div>
          <div className="transport-text-div">
            <h3>BUS</h3>
            <Link
              to="/book-ride"
              className="home-link"
              onClick={() => handleVehicleSelection("bus")}
            >
              Book Now
            </Link>
          </div>
        </div>
        <div className="home-transport-div">
          <div className="transport-img-div">
            <img src={train} alt="" />
          </div>
          <div className="transport-text-div">
            <h3>Train</h3>
            <Link
              to="/book-ride"
              className="home-link"
              onClick={() => handleVehicleSelection("train")}
            >
              Book Now
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
